import { createFileRoute, redirect, } from '@tanstack/react-router';
import { searchTherapistSearchParamsValidateCoercing, } from '@tymia/main-api';
import { api, } from '../../../api/Api.js';
import { configStore, } from '../../../common/config/ConfigStore.js';
import { reportClientError, } from '../../../error/clientErrorReporter.js';
import {} from '../../../pages/search/SearchTherapist.js';
function validateTherapistSearch(search) {
    const [isValid, params] = searchTherapistSearchParamsValidateCoercing(search);
    if (isValid) {
        // it could be an empty string, but we preserve it for redirect
        if (typeof search.postcode === 'string') {
            params.address = search.postcode;
        }
        return params;
    }
    reportClientError({
        type: 'validation-error',
        name: validateTherapistSearch.name,
        details: {
            search,
            isValid,
            params,
        },
    });
    return {};
}
export const Route = createFileRoute('/search/psychotherapists-in-{-$cityslug}')({
    validateSearch: validateTherapistSearch,
    loaderDeps: ({ search }) => search,
    beforeLoad: ({ search }) => {
        // address isn't passed as a search param. Instead we use cityslug
        // from the URL params. However, there we misuse for the migration
        if ('address' in search) {
            throw redirect({
                to: `/search/psychotherapists-in-{-$cityslug}`,
                params: {
                    cityslug: search.address ?? undefined,
                },
                replace: true,
            });
        }
    },
    async loader({ params, deps: search }) {
        const config = configStore.get();
        if (config.state !== 'initialized') {
            throw new Error('Config not initialized');
        }
        return await api.client.therapist.search.request({
            ...search,
            address: params.cityslug,
            locale: config.principal.locale,
        });
    },
});
//# sourceMappingURL=psychotherapists-in-%7B-$cityslug%7D.js.map